import { put, takeLatest } from 'redux-saga/effects'
import * as Actions from '../../auth/constants'
import { store } from '.'

function* ExTime(action) {
  try {
    const tokens = store.getState().authReducer.token
    if (tokens) {
      const jwtPayload = JSON.parse(atob(tokens.split('.')[1]))
      const JWTtime = jwtPayload.exp * 1000
      if (Date.now() > JWTtime) {
        let data = {
          user: '',
          token: '',
        }
        yield put({
          type: Actions?.LOGIN_SUCCESS,
          payload: data,
        })

        yield put({
          type: Actions?.RESTORE_USER,
          payload: '',
        })
        window.location = '/admin/login'
      }
    }
  } catch (error) {
    console.log('error', error)
  }
}

export function* fetchAfterExpiryTimeWatcher() {
  yield takeLatest('AFTER_EXPIRY_TIME', ExTime)
}

// call function by saga
// dispatch({
//   type: 'AFTER_EXPIRY_TIME',
//   payload: {
//     token: token,
//     history: null
//   }
// });